<div
  class="d-flex send-modal justify-content-between mb-4 align-items-center position-relative"
>
  <ng-container
    *ngIf="
      !receiptModal &&
      !refundModalPageOne &&
      !voidModalPageOne &&
      !refundModalPageTwo &&
      !voidModalPageTwo &&
      !refundModalLoader &&
      !voidModalLoader &&
      !refundModalSuccess &&
      !voidModalSuccess &&
      !pRefundModalPageOne &&
      !pRefundModalPageTwo &&
      !orderEditModalPageOne &&
      !orderEditModalPageTwo &&
      !cRefundModalPageOne &&
      !cRefundModalPageTwo
    "
  >
    <div
      class="f-40 fw-700 text-black paid_text text-uppercase"
      *ngIf="
        selectedTotal == 0 &&
        (payment.orderId.orderSellStatus == 3 ||
          payment.orderId.orderSellStatus == 4) &&
        payment.transactionIds[0].transactionStatus != 7 &&
        payment.transactionIds[0].transactionStatus != 6
      "
    >
      {{ (payment.orderId.orderSellStatus == 3 ? "Paid" : "Completed") | translate | async }}
      {{ payment.paymentAmount | currency : currency : "symbol" : "1.2-2" }}
    </div>
    <div
      class="f-40 fw-700 text-black paid_text text-uppercase"
      *ngIf="
        selectedTotal > 0 &&
        (payment.orderId.orderSellStatus == 3 ||
          payment.orderId.orderSellStatus == 4) &&
        payment.transactionIds[0].transactionStatus != 7 &&
        payment.transactionIds[0].transactionStatus != 6
      "
    >
      {{ (payment.orderId.orderSellStatus == 3 ? "Paid" : "Completed") | translate | async }}
      {{ selectedTotal | currency : currency : "symbol" : "1.2-2" }}
    </div>
    <div
      class="f-40 fw-700 text-black paid_text text-uppercase"
      *ngIf="
        selectedTotal == 0 && payment.orderId.orderSellStatus == 9 &&
        (payment.transactionIds[0].transactionStatus == 7 ||
          payment.transactionIds[0].transactionStatus == 6)
      "
    >
      {{ "Voided" | translate | async }}
      {{ payment.paymentAmount | currency : currency : "symbol" : "1.2-2" }}
    </div>
    <div
      class="f-40 fw-700 text-black paid_text text-uppercase"
      *ngIf="
        selectedTotal > 0 && payment.orderId.orderSellStatus == 9 &&
        (payment.transactionIds[0].transactionStatus == 7 ||
          payment.transactionIds[0].transactionStatus == 6)
      "
    >
      {{ "Voided" | translate | async }}
      {{ selectedTotal | currency : currency : "symbol" : "1.2-2" }}
    </div>
    <div
      class="f-40 fw-700 text-black paid_text text-uppercase"
      *ngIf="
        selectedTotal == 0 &&
        (payment.orderId.orderSellStatus == 5 ||
          payment.orderId.orderSellStatus == 6 ||
          payment.orderId.orderSellStatus == 7)
      "
    >
      {{
        (payment.orderId.orderSellStatus == 5
          ? "Partially Refunded"
          : payment.orderId.orderSellStatus == 6
          ? "Refunded"
          : "Cancelled") | translate | async
      }}
      {{ payment.paymentAmount | currency : currency : "symbol" : "1.2-2" }}
    </div>
    <div
      class="f-40 fw-700 text-black paid_text text-uppercase"
      *ngIf="
        selectedTotal > 0 &&
        (payment.orderId.orderSellStatus == 5 ||
          payment.orderId.orderSellStatus == 6 ||
          payment.orderId.orderSellStatus == 7)
      "
    >
      {{
        (payment.orderId.orderSellStatus == 5
          ? "Partially Refunded"
          : payment.orderId.orderSellStatus == 6
          ? "Refunded"
          : "Cancelled") | translate | async
      }}
      {{ selectedTotal | currency : currency : "symbol" : "1.2-2" }}
    </div>
    <div
      class="f-40 fw-700 text-black paid_text text-uppercase"
      *ngIf="
        selectedTotal == 0 &&
        (payment.orderId.orderSellStatus == 1 ||
          payment.orderId.orderSellStatus == 2)
      "
    >
      {{
        (payment.orderId.orderSellStatus == 1
          ? "Ordering"
          : "Payment In Progress") | translate | async
      }}
      {{ payment.paymentAmount | currency : currency : "symbol" : "1.2-2" }}
    </div>
    <div
      class="f-40 fw-700 text-black paid_text text-uppercase"
      *ngIf="
        selectedTotal > 0 &&
        (payment.orderId.orderSellStatus == 1 ||
          payment.orderId.orderSellStatus == 2)
      "
    >
      {{
        (payment.orderId.orderSellStatus == 1
          ? "Ordering"
          : "Payment In Progress") | translate | async
      }}
      {{ selectedTotal | currency : currency : "symbol" : "1.2-2" }}
    </div>
    <div
      class="f-40 fw-700 text-black paid_text text-uppercase"
      *ngIf="selectedTotal == 0 && payment.orderId.orderSellStatus == 8"
    >
      {{ "Custom Refunded" | translate | async }}
    </div>
  </ng-container>
  <ng-container *ngIf="orderEditModalPageOne || orderEditModalPageTwo">
    <div class="d-flex align-items-center gap-3">
      <span
        *ngIf="!chageLoader"
        class="back-btn fs-5"
        (click)="
          !orderEditModalPageThree
            ? backtoTransactionDetailFunc()
            : backtoEditorderPageTwoFunc()
        "
        ><i class="fas fa-arrow-left f-16"></i
      ></span>
      <h1 class="modal-title text-center w-100 fw-700">{{ "Edit Order" | translate | async }}</h1>
    </div>
  </ng-container>
  <ng-container *ngIf="receiptModal" class="send-modal">
    <span class="back-btn fs-5" (click)="backtoTransactionDetailFunc()"
      ><i class="fas fa-arrow-left f-16"></i
    ></span>
    <h1 class="modal-title text-center w-100 fw-bold">{{ "Send Receipt" | translate | async }}</h1>
  </ng-container>
  <ng-container
    *ngIf="
      refundModalPageOne ||
      refundModalLoader ||
      voidModalLoader ||
      refundModalSuccess ||
      voidModalSuccess ||
      pRefundModalPageOne ||
      cRefundModalPageOne ||
      voidModalPageOne
    "
  >
    <span
      *ngIf="
        !refundModalLoader &&
        !refundModalSuccess &&
        !voidModalLoader &&
        !voidModalSuccess
      "
      class="back-btn fs-5"
      (click)="backtoTransactionDetailFunc()"
      ><i class="fas fa-arrow-left f-16"></i
    ></span>
    <!-- <span
      *ngIf="!refundModalLoader && !refundModalSuccess && !voidModalLoader"
      class="back-btn fs-5"
      (click)="backtoTransactionDetailFunc()"
      ><i class="fas fa-arrow-left f-16"></i
    ></span> -->
    <h1 class="modal-title text-center w-100 fw-700" style="color: #b5b6b7">
      <span *ngIf="refundModalPageOne" style="color: #d50000">{{ "Full Refund" | translate | async }}</span>
      <span *ngIf="voidModalPageOne" style="color: #d50000">{{ "Void" | translate | async }}</span>
      <span *ngIf="pRefundModalPageOne">{{ "PARTIAL REFUND" | translate | async }}</span>
      <span *ngIf="cRefundModalPageOne">{{ "CUSTOM REFUND" | translate | async }}</span>
    </h1>
  </ng-container>
  <ng-container *ngIf="refundModalPageTwo">
    <span class="back-btn fs-5" (click)="backtoRefundPageOneFunc()"
      ><i class="fas fa-arrow-left f-16"></i
    ></span>
    <h1 class="modal-title text-center w-100 fw-700" style="color: #d50000">
      {{ "Full Refund" | translate | async }}
    </h1>
  </ng-container>
  <ng-container *ngIf="voidModalPageTwo">
    <span class="back-btn fs-5" (click)="backtoVoidPageOneFunc()"
      ><i class="fas fa-arrow-left f-16"></i
    ></span>
    <h1 class="modal-title text-center w-100 fw-700" style="color: #d50000">
      {{ "Void" | translate | async }}
    </h1>
  </ng-container>
  <ng-container *ngIf="pRefundModalPageTwo">
    <span class="back-btn fs-5" (click)="backtoprRefundPageOneFunc()"
      ><i class="fas fa-arrow-left f-16"></i
    ></span>
    <h1 class="modal-title text-center w-100 fw-700" style="color: #b5b6b7">
      {{ "Partial Refund" | translate | async }}
    </h1>
  </ng-container>
  <ng-container *ngIf="cRefundModalPageTwo">
    <span class="back-btn fs-5" (click)="backtoCRefundPageOneFunc()"
      ><i class="fas fa-arrow-left f-16"></i
    ></span>
    <h1 class="modal-title text-center w-100 fw-700" style="color: #b5b6b7">
      {{ "Custom Refund" | translate | async }}
    </h1>
  </ng-container>
  <div class="align-self-center">
    <button
      type="button"
      class="btn-close f-14 btn-details"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>
</div>
